/* eslint-disable no-param-reassign */
import { BULK_MOVE_MAP_LAYERS } from 'components/route-manager/BulkActions/settings'
import { createBulkActionSlice } from 'slices/generic/createBulkActionSlice'
import { get } from 'utils/lodash'

const { FROM_ROUTE_LAYER } = BULK_MOVE_MAP_LAYERS

const bulkUnassignStopsSlice = createBulkActionSlice({
  name: 'bulkUnassignStops',
})
export const {
  setBulkState: setBulkUnassignStopsState,
  addSelectedMoveToRows,
  addSelectedMoveFromRows,
  removeSelectedMoveFromRows,
  removeSelectedMoveToRows,
  toggleSelectedMoveFromRow,
  toggleSelectedMoveToRow,
  setSelectedMoveFromRows,
  setSelectedMoveToRows,
} = bulkUnassignStopsSlice.actions

// Seed pushed by an external surface (the board-v2 per-column Bulk unassign) to
// open this dialog pre-targeted instead of via its route/date picker. Shape:
// { routeId, serviceDate (Date), selectedStopIds: string[] }. The dialog
// consumes it once on open, then clears it. Null/absent → legacy picker flow.
export const selectBulkUnassignSeed = state => get(state, 'bulkUnassignStops.seed', null)

export const selectIsOpenBulkUnassignStopsDialog = state => get(state, 'bulkUnassignStops.isOpen', false)
export const selectIsSelectDateDialogOpen = state => get(state, 'bulkUnassignStops.isSelectDateDialogOpen', false)
export const selectIsOpenBulkUnassignConfirmCloseDialog = state => get(state, 'bulkUnassignStops.isConfirmCloseDialogOpen', false)
export const selectBulkUnassignFromRouteSequenceLine = state => get(state, 'bulkUnassignStops.moveFromRouteSequenceLine', {})
export const selectBulkUnassignFromRouteContainerFeatures = state => get(state, 'bulkUnassignStops.moveFromRouteContainerFeatures', [])
export const selectBulkUnassignFromRouteDailyGeoJsonId = state => get(state, 'bulkUnassignStops.moveFromRouteDailyGeoJsonId')
export const selectBulkUnassignFromRouteStopMarkers = state => get(state, 'bulkUnassignStops.moveFromRouteStopMarkers', [])
export const selectBulkUnassignFromRows = state => get(state, 'bulkUnassignStops.moveFromRows', [])
export const selectBulkSelectedMoveFromRows = state => get(state, 'bulkUnassignStops.selectedMoveFromRows', [])
export const selectBulkUnassignToRouteStopMarkers = state => get(state, 'bulkUnassignStops.moveToRouteStopMarkers', [])
export const selectBulkUnassignToRows = state => get(state, 'bulkUnassignStops.moveToRows', [])
export const selectBulkSelectedMoveToRows = state => get(state, 'bulkUnassignStops.selectedMoveToRows', [])
export const selectBulkUnassignRoutesById = state => get(state, 'bulkUnassignStops.routesById', {})
export const selectBulkUnassignFitBounds = state => get(state, 'bulkUnassignStops.fitBounds', false)
export const selectBulkUnassignMapLayer = state => get(state, 'bulkUnassignStops.mapLayer', FROM_ROUTE_LAYER)

export default bulkUnassignStopsSlice.reducer
